import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

// const isProduction = import.meta.env.PROD;
const routes = [
  {
    path: '/',
    name: 'ArticleList',
    component: () => import('../views/article/list.vue'),
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import('../views/article/detail.vue'),
  },
  {
    path: '/editor',
    name: 'ArticleAdd',
    component: () => import('../views/article/editor.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/editor/:id',
    name: 'ArticleModify',
    component: () => import('../views/article/editor.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/preview',
    name: 'ArticlePreview',
    component: () => import('../views/article/preview.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory('/blog'),
  routes,
});

// 路由守卫
router.beforeEach(async (to) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth) {
    const isValidSession = await authStore.ensureValidSession();

    if (!isValidSession) {
      // 需要登录但登录态无效，跳转到登录页
      return {
        name: 'Login',
        query: { redirect: to.fullPath },
      };
    }
  }

  if (to.name === 'Login') {
    const isValidSession = await authStore.ensureValidSession();

    if (isValidSession) {
      // 已登录用户访问登录页，跳转到首页
      return { name: 'ArticleList' };
    }
  }

  return true;
});

export default router;
